//Built-In
import React, {Fragment} from 'react';
//External
import { faListUl, faPhone, faUpRightFromSquare, faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Player, ControlBar } from 'video-react';
import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import '../Templates/CarouselModal.css';
import ReactAudioPlayer from 'react-audio-player';
import mapImage from './../../assets/utils/images/map_img.jpg';
//Internal
import {decodeString, getWABodyVariables, replaceSymbolsToHtml,parseJSON} from "../../Common/Appcommon";
import AudioPlayer from "./AudioPlayer";
import CarouselTemplatePreview from "./CarouselTemplatePreview";
import pdfIcon from "./../../assets/utils/images/pdf.png";
import csvIcon from "./../../assets/utils/images/csv.png";
import requestApiService from '../../services/requestApi.service';
export default class PreviewBox extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            repliedFormInfo : [],
            carouselIndex: 0,
        }

    }
    async componentDidMount() {
  const { formInfo, is_Replied,source} = this.props;
  if(source == 'list-table'){
            await this.getRepliedMsgContent(formInfo, is_Replied);
        }
    }

    async componentDidUpdate(prevProps) {
  const { formInfo, is_Replied,source } = this.props;
        if (source == 'list-table' && (formInfo !== prevProps.formInfo || is_Replied !== prevProps.is_Replied)) {
            await this.getRepliedMsgContent(formInfo, is_Replied);
        }
    }
    openGivenUrl = (e, url) => {
        e.preventDefault();
        window.open(url, '_blank').focus();
    }

    nextCard = (e, total) => {
        e.preventDefault();
        if (this.state.carouselIndex < total - 1) {
            this.setState({ carouselIndex: this.state.carouselIndex + 1 });
        }
    }

    prevCard = (e) => {
        e.preventDefault();
        if (this.state.carouselIndex > 0) {
            this.setState({ carouselIndex: this.state.carouselIndex - 1 });
        }
    }

    getRepliedMsgContent = async (formInfo,is_Replied) => {
        let {repliedFormInfo} = this.state;
        if(is_Replied === "1"){
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "GETREPLIEDANALYTICS",
                "formInfo": formInfo,
                "isOtherApiReq": true,
            }
            let response = await requestApiService.processServerRequest(params,"WebV2");
            if(response.issuccess && response.data.length > 0){
                repliedFormInfo = response.data;
                        await console.log("REPLY MSG:Message_Info  ",repliedFormInfo[0]['Message_Info']);

                if(repliedFormInfo[0]['Message_Info'] !== undefined && repliedFormInfo[0]['Message_Info']  !== '' && repliedFormInfo[0]['Message_Info']  != null){
                repliedFormInfo[0]['Message_Info']  = parseJSON(decodeString(repliedFormInfo[0]['Message_Info'] ));
                }
                        await console.log("REPLY MSG:1 "+JSON.stringify(repliedFormInfo[0]['Message_Info']));

                repliedFormInfo = repliedFormInfo[0];
                this.setState({repliedFormInfo});
            }
        }
        return repliedFormInfo;
    }
    getFullMediaUrl = (pathOrId) => {
        const awsUrl = process.env.REACT_APP_CRATIO_AWS_S3_URL;
        if (!pathOrId) return "";
        // If it's a full URL (starts with http), return as-is
        if (pathOrId.startsWith("http")) return pathOrId;
        // Otherwise assume it's a file path or media id from your system
        return `${awsUrl}${pathOrId.startsWith("/") ? pathOrId : "" + pathOrId}`;
    };

    truncateMiddle = (filename, maxLength = 20)=> {
        if (filename.length <= maxLength) return filename;
        const extIndex = filename.lastIndexOf('.');
        const ext = extIndex > -1 ? filename.slice(extIndex) : '';
        const name = extIndex > -1 ? filename.slice(0, extIndex) : filename;
        const visibleChars = maxLength - ext.length - 3; // 3 for "..."
        const start = Math.ceil(visibleChars / 2);
        const end = name.length - Math.floor(visibleChars / 2);
        return `${name.slice(0, start)}...${name.slice(end)}${ext}`;
    }
    render() {
        let { components, waComponents, formData, previewData, source,msgContentType,temptype } = this.props;
        let {repliedFormInfo} = this.state;
        let medialUrl = formData['mediaUrl'];
        let pdfname = (waComponents['BODY'] !== undefined && waComponents['BODY']['text'] !== undefined && waComponents['BODY']['text'] !== null) ? waComponents['BODY']['text'] : '';
        const current = new Date();
        // By default US English uses 12hr time with AM/PM
        const time = current.toLocaleTimeString("en-US");
        if(msgContentType === undefined){
            msgContentType = "";
        }
        if (components && Array.isArray(components) && components.some(c => c.type === 'CAROUSEL')) {
            return <CarouselTemplatePreview components={components} formData={formData} formInfo={this.props.formInfo} source={source} />;
        }

        return (
            <Fragment>
                <div className={cx('flex gap-3 ',{ 
                    'preview-inner-content' : source !== 'inbox'
                })}>
                    <div className={cx('', {
                        'pv-c-2 ': source !== 'inbox'
                    })}>
                        <div className={cx('', {
                            'pv-c-3': source !== 'inbox'
                        })}>
                            <div className={'pv-ru .pr'}>
                                {
                                    components &&
                                    Array.isArray(components) &&
                                    components.map((component, index) => {
                                        let type = component['type'];
                                        let formatname = component['format'];
                                        let isDoc = false;
                                        if (formatname === 'DOCUMENT') {
                                            isDoc = true;
                                        }
                                        if (type === "HEADER") {
                                            if (temptype === "Standard Card") return null;
                                            let format = component['format'];
                                            let headerText = component['text'] || "";
                                            let footerrText = "";
                                            let defaultclass = format.toLowerCase() + "-preview header-preview";
                                            let customTag = "";
                                            let parentHeight = (format === "IMAGE" || format === "VIDEO" || format === "LOCATION") && medialUrl ? "height-150" : "";

                                            if (headerText !== "") {
                                                let variables = getWABodyVariables(headerText);
                                                variables.map((variable) => {
                                                    let prefix = this.props.isCarousel && this.props.cardIndex !== undefined ? `carousel_card_${this.props.cardIndex}_` : '';
                                                    let variableHeaderFieldPrefix = prefix + "header_variable_" + variable + "_label";
                                                    let defaultHeaderValuePrefix = prefix + "header_df_value_field_" + variable;
                                                    let defaultHeaderLeadValuePrefix = prefix + "header_df_lead_value_field_" + variable;

                                                    let fieldReplaceContent = "{{" + variable + "}}";

                                                    let fieldLabel = previewData?.[variableHeaderFieldPrefix] || "";
                                                    let defaultValue = formData?.[defaultHeaderValuePrefix] || "";
                                                    let dafaultLeadValue = formData?.[defaultHeaderLeadValuePrefix] || "";

                                                    if (dafaultLeadValue !== "") {
                                                        headerText = headerText.replaceAll(fieldReplaceContent, dafaultLeadValue);
                                                    } else if (fieldLabel !== "" && defaultValue === "") {
                                                        fieldLabel = "$" + fieldLabel + "$";
                                                        headerText = headerText.replaceAll(fieldReplaceContent, fieldLabel);
                                                    } else if (defaultValue !== "") {
                                                        headerText = headerText.replaceAll(fieldReplaceContent, defaultValue);
                                                    }
                                                });
                                                
                                                headerText = replaceSymbolsToHtml(headerText);
                                            }

                                            if (format === "TEXT") {
                                                parentHeight = "";
                                                defaultclass = format.toLowerCase() + "-preview";
                                            } else if (format === "IMAGE"){
                                                if(medialUrl !== undefined && medialUrl !== "") {
                                                    customTag = <img className={'preview-image-tag'} src={medialUrl}/>;
                                                    defaultclass = "bg-white header-preview";
                                                    if (temptype == 'Bot') {
                                                        footerrText = <div className={'footer-bg-auto'}></div>
                                                    }
                                                } else {
                                                    return null;
                                                }
                                                if (headerText !== "") {
                                                    headerText = <div className="header-title-text font-weight-bold mb-1">{headerText}</div>;
                                                }
                                            } else if (format === "VIDEO") {
                                                if (medialUrl !== undefined && medialUrl !== "") {
                                                    parentHeight = "";
                                                    customTag = (<Video loop muted
                                                        controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
                                                        onCanPlayThrough={() => {
                                                            // Do stuff
                                                        }}>
                                                        <source src={medialUrl} />
                                                    </Video>)
                                                    defaultclass = "bg-white header-preview mw-330";
                                                    if (temptype == 'Bot') {
                                                        footerrText = <div className={'footer-bg-auto'}></div>
                                                    }
                                                } else {
                                                    return null;
                                                }
                                                if (headerText !== "") {
                                                    headerText = <div className="header-title-text font-weight-bold mb-1">{headerText}</div>;
                                                }
                                            } else if (format === "AUDIO") {
                                                parentHeight = "";
                                                if (medialUrl !== undefined) {
                                                    customTag = (<AudioPlayer audioUrl={medialUrl} />);
                                                    defaultclass = "bg-none header-preview";
                                                }
                                            } else if (format === "LOCATION") {
                                                if (medialUrl !== undefined) {
                                                    customTag = (<a target={`_blank`} rel="noopener noreferrer" href={"javascript:void(0)"} onClick={(event => { this.openGivenUrl(event, `https://www.google.com/maps/search/?api=1&query=${medialUrl.latitude},${medialUrl.longitude}`) })} ><img className={`location-img`} src={mapImage} /></a>);
                                                    defaultclass = "bg-white header-preview height-150";
                                                }
                                            } else if (format === "DOCUMENT") {
                                                defaultclass = "header-preview document-preview mw-330";
                                                let pdfname = "";
                                                if (medialUrl !== "" && medialUrl !== undefined) {
                                                    pdfname = medialUrl.substring(medialUrl.lastIndexOf('/') + 1);
                                                    let fileFormat = pdfname.split(".")[1];
                                                    let bgIcon = csvIcon;
                                                    if (fileFormat === "pdf") {
                                                        bgIcon = pdfIcon;
                                                    }
                                                    defaultclass = "bg-white text-danger document-tmp header-preview text-stylesdoc  mw-330";
                                                    headerText = <div className="document-header-group">{headerText}<a className='pdfnamecss' target={`_blank`} title={"Document"} href={"javascript:void(0)"} onClick={(event => { this.openGivenUrl(event, medialUrl) })}><img className={'pdf-image-tag'} src={bgIcon} /><div className={'document-name'}><h6 className='document-file-type-name'>{pdfname}</h6><div className='docformat'>{fileFormat !== undefined ? fileFormat.toUpperCase() : ""}</div></div></a></div>;
                                                }
                                            }
                                            return (
                                                <div className={cx(`header-portion ${parentHeight}`, {
                                                    'pd-none': source === 'inbox'
                                                })}>
                                                    <div className={defaultclass} >
                                                        {headerText}
                                                        {customTag}
                                                        {footerrText}

                                                    </div>
                                                </div>
                                            )
                                        } else if (type === "BODY") {
                                            let bodyText = component['text'];
                                            let variables = getWABodyVariables(bodyText);
                                            let variableFieldPrefix = "body_variable_field_";
                                            let defaultValuePrefix = "body_df_value_field_";
                                            let defaultLeadValuePrefix = "body_df_lead_value_field_";
                                            variables.map((variable, index) => {
                                                let tmpFieldPrefix = variableFieldPrefix + variable;
                                                let labelPrefix = tmpFieldPrefix + "_label";
                                                let fieldReplaceContent = "{{" + variable + "}}";
                                                let fieldValue = formData[tmpFieldPrefix] === undefined ? "" : formData[tmpFieldPrefix];
                                                let fieldLabel = (previewData !== undefined && previewData[labelPrefix] !== undefined) ? previewData[labelPrefix] : "";
                                                let defaultValue = formData[defaultValuePrefix + variable] === undefined ? "" : formData[defaultValuePrefix + variable];
                                                let dafaultLeadValue = formData[defaultLeadValuePrefix + variable] === undefined ? "" : formData[defaultLeadValuePrefix + variable];

                                                if(dafaultLeadValue !== ""){
                                                    bodyText = bodyText.replaceAll(fieldReplaceContent, dafaultLeadValue);
                                                } else if(fieldLabel !== "" && defaultValue === "") {
                                                    fieldLabel = source !== 'template_send' ? "$"+fieldLabel+"$" : '-';
                                                    bodyText = bodyText.replaceAll(fieldReplaceContent, fieldLabel);
                                                } else if (defaultValue !== ""){
                                                    bodyText = bodyText.replaceAll(fieldReplaceContent, defaultValue);
                                                }
                                            })

                                            { bodyText = replaceSymbolsToHtml(bodyText + "") }
                                            return (
                                                <div className={cx('content-portion', {
                                                    'pd-none': !isDoc || bodyText === '' || (bodyText !== undefined && bodyText.length === 0),

                                                })}>

                                                    <span className={cx('', {
                                                        'content-preview': isDoc,
                                                    })}>
                                                        {(Object.keys(bodyText).length > 0 /*&& msgContentType !== "document" && !isDoc*/) &&
                                                            <div className="text-body " dir="auto">
                                                                <span className={'content-preview'} dir="auto">{bodyText}</span>
                                                            </div>
                                                        }

                                                    </span>
                                                </div>
                                            )
                                        } else if (type === "FOOTER") {
                                            let footerText = component['text'];
                                            return (
                                                <div className={'footer-portion'}>
                                                    {footerText}
                                                </div>
                                            )
                                        }
                                    })
                                }

                                <time className={cx('time-portion', {
                                    "hide": source === 'inbox'
                                })} aria-hidden={'true'} >{time}</time>
                            </div>
                            {
                                waComponents['BUTTONS'] !== undefined &&
                                waComponents['BUTTONS']['buttons'].map((button, index) => {
                                    let btnType = (button['type'] || "").toUpperCase();
                                    let btnText = button['text'];
                                    let btnUrl = "";
                                    let btnIcon = "";
                                    if (btnType === "URL") {
                                        btnUrl = button['url'];
                                        btnIcon = faUpRightFromSquare;
                                    } else if (btnType === "CALL" || btnType === "PHONE_NUMBER") {
                                        btnUrl = button['phone_number'] || button['url'];
                                        btnIcon = faPhone;
                                    } else if (btnType === "LIST") {
                                        btnIcon = faListUl;
                                    } else if (btnType === "REPLY" || btnType === "QUICK_REPLY") {
                                        btnIcon = '';
                                    }
                                    return (
                                        <div className={cx('button-panel',
                                            {
                                                'button-panel-first': index === 0 && (btnType !== "REPLY" && btnType !== "QUICK_REPLY"),
                                                'button-panel-reply': btnType === "REPLY" || btnType === "QUICK_REPLY"
                                            })}>
                                            <div className={'button-panel-content items-center content-justify list-group-horizontal dis-flex'}>
                                                {
                                                    btnIcon !== '' &&
                                                    <span aria-hidden={true} className={cx("link-icn", { 'link-bg-img': false })} />
                                                }
                                                {btnIcon !== '' && <FontAwesomeIcon icon={btnIcon} />}
                                                <span className={'btn-text ml-1'}>{btnText}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                    {repliedFormInfo && Object.keys(repliedFormInfo).length > 0 && source == 'list-table' && (
                        <div className="mt-2 p-2 bg-gray-50 rounded-xl border border-gray-200 " style={{ height: 'fit-content' }} >
                            <p className="text-sm font-semibold text-gray-600 mb-2" style={{ width: source === 'list-table' ? 'max-content' : '' }}>💬 Reply Message</p>

                            {(() => {
                                const msgInfo = repliedFormInfo?.Message_Info;
                                const messages = msgInfo?.entry?.[0]?.changes?.[0]?.value?.messages || [];
                                const formId = repliedFormInfo?.table_74_0_table_74_id;
                                const onOpenWhatsappChatAction = (e, formId) => {
                                    e.stopPropagation();
                                    let formIdstr = formId == null ? "" : "/" + formId;
                                    window.open(`#/inbox/chat${formIdstr}`, "_blank");
                                };

                                return messages.map((msg, i) => {
                                    const msgType = msg.type || "text";
                                    const msgBody = msg.text?.body || "";
                                    const mediaUrl = repliedFormInfo?.Media_URL || "";
                                    const buttonText = msg.button?.text || msg.button?.payload || "";
                                    const reactionEmoji = msg.reaction?.emoji || "";

                                    return (
                                        <div
                                            key={i}
                                            className="cursor-pointer hover:bg-gray-100 p-2 rounded-lg border-gray-200 "
                                            onClick={(e) => onOpenWhatsappChatAction(e, formId)}
                                        >
                                            {msgType === "text" && (
                                                <div className="p-2 template-name bg-green-50 text-gray-800 text-sm rounded-md inline-block max-w-xs">
                                                    {msgBody}
                                                </div>
                                            )}

                                            {msgType === "button" && (
                                                <div className="p-2 template-name bg-blue-50 text-blue-800 text-sm rounded-md inline-block max-w-xs">
                                                    {buttonText}
                                                </div>
                                            )}

                                            {msgType === "image" && mediaUrl && (
                                                <img
                                                    src={this.getFullMediaUrl(msg.image?.url || repliedFormInfo?.Media_URL || "")}
                                                    alt="Replied media"
                                                    className="rounded-lg max-h-56 object-cover border mt-1"
                                                    style={{ width: source === 'list-table' ? '242px' : '' }} />
                                            )}

                                            {msgType === "video" && (
                                                <video
                                                    controls
                                                    className="rounded-lg max-h-64 object-cover border mt-1"
                                                    style={{ height: source === 'list-table' ? '350px' : '' }}
                                                >
                                                    <source
                                                        src={this.getFullMediaUrl(repliedFormInfo?.Media_URL || msg.video?.id)}
                                                        type={msg.video?.mime_type || "video/mp4"}
                                                    />
                                                    Your browser does not support the video tag.
                                                </video>
                                            )}
                                            {msgType === "audio" && (
                                                <audio
                                                    controls
                                                    className="mt-2 w-60 rounded-md border"
                                                >
                                                    <source
                                                        src={this.getFullMediaUrl(repliedFormInfo?.Media_URL || msg.audio?.id)}
                                                        type={msg.audio?.mime_type || "audio/ogg"}
                                                    />
                                                    Your browser does not support the audio element.
                                                </audio>
                                            )}
                                            {msgType === "document" && (
                                                <a
                                                    href={this.getFullMediaUrl(mediaUrl)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="block mt-2 text-blue-600 underline text-sm"
                                                >
                                                    📄 {this.truncateMiddle(msg.document?.filename || "attachment")}
                                                </a>
                                            )}
                                            {msgType === "reaction" && (
                                                <div className="p-2 bg-yellow-50 text-yellow-800 text-sm rounded-md inline-block max-w-xs">
                                                    {reactionEmoji}
                                                </div>
                                            )}
                                        </div>
                                    );
                                });
                            })()}
                        </div>
                    )}

                </div>

            </Fragment>

        );
    }
}
